import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MockAuthService } from '../../ngrx/auth/mock-auth.service';
@Injectable({
  providedIn: 'root',
})
export class WhileGuard {
  constructor(private mockAuthService: MockAuthService) {}

  canActivate() {
    if (environment.mockAuthentication) {
      const authToken = this.mockAuthService.getToken();
      if (authToken) {
        // return location.replace('dashboard')
      }
    }
    return true;
  }
}
